import { Injectable } from '@angular/core';
import * as configdata from "../../assets/config/config.json"

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  static settings: IAppConfig;

  xml: any;
  xmlrespose: any;
  dataarray: any;

  constructor() {
    const config = (configdata as any).default || configdata;
    AppConfigService.settings = {
      ...config,
      RouteNameSuggest: config.RouteNameSuggest || []
    };
  }

  load() {
    const config = (configdata as any).default || configdata;
    AppConfigService.settings = {
      ...config,
      RouteNameSuggest: config.RouteNameSuggest || []
    };
    return AppConfigService.settings;
  }
}

export interface IAppConfig {
  UserLogin: any;
  WebApiURL: any;
  WebApiDotComURL: any;
  RouteNameSuggest: any;
}

